<template lang="html">
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
		<circle style="fill:#44C4A1;" cx="256" cy="256" r="256"/>
		<g>
			<path style="fill:#FFFFFF;" d="M86.4,487.2L196,344c6.4-8,5.6-19.2-1.6-26.4c-7.2-7.2-18.4-8-26.4-1.6L24.8,425.6
				c-20.8,16-23.2,46.4-4,65.6C39.2,509.6,70.4,508,86.4,487.2z"/>
				<rect x="116.402" y="313.342" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 52.7086 701.3156)" style="fill:#FFFFFF;" width="110.399" height="52.799"/>
			<circle style="fill:#FFFFFF;" cx="314.4" cy="197.6" r="189.6"/>
		</g>
		<path style="fill:#FFBF5D;" d="M314.4,355.2c-87.2,0-157.6-70.4-157.6-157.6C156.8,110.4,228,40,314.4,40
			C401.6,40,472,110.4,472,197.6C472,284,401.6,355.2,314.4,355.2L314.4,355.2z"/>
		<g>
			<path style="fill:#193651;" d="M314.4,0C205.6,0,116.8,88.8,116.8,197.6c0,31.2,7.2,60.8,20.8,87.2l-28.8,28.8
				c-3.2,3.2-3.2,8,0,11.2l14.4,14.4L20.8,418.4C-4,437.6-5.6,474.4,16,496c21.6,21.6,58.4,20,77.6-4.8l79.2-102.4l14.4,14.4
				c1.6,1.6,4,2.4,5.6,2.4s4-0.8,5.6-2.4l28.8-28.8c26.4,12.8,56,20.8,87.2,20.8c108.8,0,197.6-88.8,197.6-197.6S423.2,0,314.4,0z
				M80.8,481.6C68,498.4,42.4,500,27.2,484.8c-15.2-15.2-13.6-40,3.2-53.6l104.8-80.8l25.6,25.6L80.8,481.6z M192.8,386.4l-67.2-67.2
				l19.2-19.2c16.8,27.2,39.2,50.4,67.2,67.2L192.8,386.4z M314.4,379.2v8V379.2c-100,0-181.6-81.6-181.6-181.6
				c0-100,81.6-181.6,181.6-181.6S496,97.6,496,197.6S414.4,379.2,314.4,379.2z"/>
			<rect x="196" y="144" style="fill:#193651;" width="15.2" height="107.2"/>
			<rect x="400" y="144" style="fill:#193651;" width="11.2" height="107.2"/>
			<rect x="223.2" y="144" style="fill:#193651;" width="22.4" height="107.2"/>
			<rect x="378.4" y="144" style="fill:#193651;" width="10.4" height="107.2"/>
			<rect x="339.2" y="144" style="fill:#193651;" width="7.2" height="107.2"/>
			<rect x="354.4" y="144" style="fill:#193651;" width="15.2" height="107.2"/>
			<rect x="275.2" y="144" style="fill:#193651;" width="15.2" height="107.2"/>
			<rect x="421.6" y="144" style="fill:#193651;" width="11.2" height="107.2"/>
			<rect x="256.8" y="144" style="fill:#193651;" width="10.4" height="107.2"/>
			<rect x="322.4" y="144" style="fill:#193651;" width="7.2" height="107.2"/>
			<rect x="299.2" y="144" style="fill:#193651;" width="15.2" height="107.2"/>
			<rect x="263.2" y="293.6" style="fill:#193651;" width="16" height="16"/>
			<rect x="306.4" y="293.6" style="fill:#193651;" width="16" height="16"/>
			<rect x="349.6" y="293.6" style="fill:#193651;" width="16" height="16"/>
			<rect x="263.2" y="85.6" style="fill:#193651;" width="16" height="16"/>
			<rect x="306.4" y="85.6" style="fill:#193651;" width="16" height="16"/>
			<rect x="349.6" y="85.6" style="fill:#193651;" width="16" height="16"/>
			<rect x="39.708" y="458.387" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 411.2282 762.437)" style="fill:#193651;" width="16" height="16"/>
			<rect x="70.284" y="428.051" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 441.9741 689.0302)" style="fill:#193651;" width="16" height="16"/>
			<rect x="100.852" y="397.731" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 472.7177 615.6564)" style="fill:#193651;" width="16" height="16"/>
		</g>
  </svg>

</template>

<script>
export default {
  name: 'AssociateItem'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/AssociateItem.vue